import type {CSSProperties} from 'react';
import {radius, space} from '../scale.js';
import {wedgeExactRole} from './wedgeRoles.js';

export type WedgeSignalFeedLook = 'signal-feed-row' | 'signal-feed-row-ruled' | 'signal-feed-row-refused' | 'signal-feed-row-ruled-refused' | 'signal-feed-rail' | 'signal-feed-rail-refused';

/* Released industry signal feed of Today ("Live in your patch"): one headline link per item. The card row is a block link with
   12px by 14px padding; every row after the first has a 0.5px hairline above it. The rail row (the 300px desktop rail) is a block
   link with 8px by 6px padding and a 10px radius, with no rule. Both inherit the ink and the font of the row, draw no underline and
   keep the pointer cursor. A refused row (the protocol guard dropped its URL) is the same link with the default cursor. The hairline
   reads the exact legacy role, so the shipped light-theme rules keep matching the serialized style. The caller owns the headline,
   the source line, the href, the target and the rel, and keeps the refused row a link to "#". */
const ROW_PX = 14, RAIL_PX = 6, RULE = 0.5;

export function wedgeSignalFeedStyle(look: WedgeSignalFeedLook): CSSProperties {
  const cursor = look.endsWith('-refused') ? 'default' : 'pointer';
  if (look.startsWith('signal-feed-rail')) return {
    display: 'block', padding: `${space[2]}px ${RAIL_PX}px`, borderRadius: radius.md,
    textDecoration: 'none', color: 'inherit', cursor,
  };
  return {
    display: 'block', padding: `${space[3]}px ${ROW_PX}px`,
    borderTop: look.startsWith('signal-feed-row-ruled') ? `${RULE}px solid ${wedgeExactRole('separator')}` : 'none',
    textDecoration: 'none', color: 'inherit', cursor,
  };
}
